/**
 * ディレクトリが存在するか調べる
 */
module.exports = function( path ){
    var fs = require('fs');
    if( !fs.existsSync(path) || !fs.statSync(path).isDirectory() ){
        return false;
    }
    return true;
}
